export default "__VITE_ASSET__a9f4401d__"